<template>
    <span>
        {{ timeLeft }}
    </span>
</template>

<script>
    import Vue from 'vue';

    import {
        absoluteTime,
        TimeInterval,
    } from '@shared/filters';

    const ms = require('ms');

    export default Vue.component('Timer', {
        emits: ['timeExpired'],
        props: {
            endDate: {
                type: Date,
                required: true,
                validator(value) {
                    return value >= 0;
                },
            },
        },
        data() {
            return {
                timeLeft: null,
                options: {
                    inputTimeInterval: TimeInterval.s,
                    outputTimeFormat: [TimeInterval.m, TimeInterval.s],
                },
            };
        },
        mounted() {
            this.intervalFn = this.startTimer();
            this.timeLeft = absoluteTime(this.calculateTimeLeft(), this.options);
        },
        methods: {
            updateTimer() {
                const timeLeft = this.calculateTimeLeft();
                if (timeLeft <= 0) {
                    this.$emit('timeExpired');
                    this.stopTimer();
                    return;
                }
                this.timeLeft = absoluteTime(timeLeft, this.options);
            },
            calculateTimeLeft() {
                return Math.max((this.endDate.getTime() - Date.now()) / 1000, 0);
            },
            startTimer() {
                return setInterval(this.updateTimer, ms('1s'));
            },
            stopTimer() {
                clearInterval(this.intervalFn);
            },
        },
        beforeDestroy() {
            this.stopTimer();
        },
    });
</script>
